import React from 'react';
import Text from '../../atoms/text';
import Button from '../../atoms/button';
import './style.scss';

const Error = () => (
  <div className="error">
    <Text>
      Parece que ocorreu um erro ao processar sua requisição. Por favor tente
      novamente.
    </Text>
    <Button to={window.location.href} title="Tentar novamente" external>
      Tentar novamente
    </Button>
  </div>
);

export default Error;
